module.exports = __webpack_public_path__ + "img/contact_image0.92dd4298.jpg";